<script lang="ts" setup>
import type { PropType } from 'vue'
import type { ImportStatus } from '~/models/importStatus'
import { useRefreshStatus } from '~/compositions/useRefreshStatus'

const props = defineProps({
  importStatus: {
    type: Object as PropType<ImportStatus>,
    required: true,
  },
})

const { loading, refreshStatus } = useRefreshStatus(
  () => ({
    container_number: props.importStatus.container_number,
    portal: props.importStatus.source,
    terminal: props.importStatus.terminal,
    shipping_line: undefined,
  }),
  toRef(props.importStatus, 'last_observed'),
  'import status'
)
</script>

<template>
  <RefreshButton
    :loading="loading"
    class="fs-refresh-import-status-button"
    @click="refreshStatus"
  />
</template>
